<template>
  <div ref="sidebar" class="sidebar">
    <transition name="fade">
      <div v-if="isOpened" class="sidebar-backdrop" @click="onBackdropClick"></div>
    </transition>
    <transition name="slide">
      <div v-if="isOpened" class="sidebar-panel" :class="sidebarClasses">
        <slot v-if="isModal" name="close-button">
          <icon-button
            :icon-name="$options.closeIcon"
            class="sidebar-close-button"
            @click="onBackdropClick"
          />
        </slot>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import IconButton from '@/components/common/IconButton.vue';

import { toggleDocumentScroll } from '@/utils/common';

import { ICON } from '@/constants/icons';

export default {
  name: 'SidebarSection',
  components: { IconButton },
  closeIcon: ICON.CLOSE,
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    mobileLeftPadding: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    withHeaderIndent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sidebarClasses() {
      return {
        'sidebar-panel--with-mobile-left-padding': this.mobileLeftPadding,
        'sidebar-panel--modal': this.isModal,
        'sidebar-panel--with-header-indent': this.withHeaderIndent
      };
    }
  },
  watch: {
    isOpened: 'togglePageScroll'
  },
  beforeDestroy() {
    this.togglePageScroll(false);
  },
  methods: {
    onBackdropClick() {
      this.$emit('close-sidebar');
    },
    togglePageScroll(isOpen) {
      toggleDocumentScroll(this.$refs.sidebar, isOpen);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/sidebar-section.scss';
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/header.scss';

.sidebar-backdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.25);

  cursor: pointer;
  z-index: 1001;
}

.sidebar-panel {
  height: 100vh;
  width: 50vw;

  position: fixed;
  right: 0;
  top: 0;

  background-color: $seashell-peach-color;
  border-left: 1px solid $timberwolf-color;

  z-index: 1002;

  &--with-mobile-left-padding {
    width: 87.5%;
  }

  &--modal {
    width: 100%;
  }

  &--with-header-indent {
    height: calc(100% - #{$header-height});
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.9s cubic-bezier(0.14, 0.29, 0.24, 0.96);
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

@media (min-width: 600px) {
  .sidebar-panel {
    &--with-mobile-left-padding {
      width: 50vw;
    }

    &--modal {
      width: 600px;
    }
  }
}

@media (min-width: 960px) {
  .sidebar-panel {
    &--with-header-indent {
      height: calc(100% - #{$header-height-960});
    }
  }
}

@media (min-width: 1264px) {
  .sidebar-panel {
    &--with-header-indent {
      height: calc(100% - #{$header-height-1264});
    }
  }
}

@media (min-width: 1920px) {
  .sidebar-panel {
    &--with-header-indent {
      height: calc(100% - #{$header-height-1920});
    }
  }
}
</style>
